import EvaluationPage from "../../pages/EvaluationPage";
import { EvaluationProvider, initialState, ageRangeOptions, sportSeasonOptions, genderOptions, athleteLevelOptions } from "../../contexts/EvaluationContext";

const presetData = {
  ...initialState,
  session: { ...initialState.session, id: "session123", user: "testuser" },
  evaluation: { ...initialState.evaluation, id: "eval456", name: "Wellness Survey", accountManagerEmail: "something@gmail.com" },
  demographics: {
    ageRangeOptions,
    sportSeasonOptions,
    genderOptions,
    athleteLevelOptions,
    ageRange: "2",
    sportSeason: "1",
    gender: "1",
    athleteLevel: "3"
  }
};

const EvaluationTest = () => {
    return (
        <div>
            <div>
                Evaluation Test Component
            </div>
        <EvaluationProvider initial={presetData}>
           <EvaluationPage />
        </EvaluationProvider>
        </div>
    );
}

export default EvaluationTest;

// TODO:
// Fix Answer Choices to include text and score
// Add Next/Submit button functionality
// Add Cancel Session functionality

// scale table
// ID:   Name:         Description:                    Threshold:
// 1     Frequency     "How often does this occur?"        3

// answer table
// ID:    ScaleId:      Order:    Text:        Help:     Score:
// 1         1           1        Never        ...        0
// 2         1           2        Rarely       ...        1
// 3         1           3        Sometimes    ...        2
// 4         1           4        Often        ...        3
// 5         1           5        Always       ...        4

// 1         1           1        Never        ...        4
// 2         1           2        Rarely       ...        3
// 3         1           3        Sometimes    ...        2
// 4         1           4        Often        ...        1
// 5         1           5        Always       ...        0

// question table
// ID:   Text:         Help:        Example:     Sequence:   ScaldId:  Type:      Threshold:
// 10   "How often..."  "Help text"  "Example"       1           1     Wellness       3
// 20   "Do you feel..." "Help text" "Example"       1           1     Concern        2
// 30   "Has anyone..."  "Help text" "Example"       1           1     Abuse          4 